/**
 * Types
 */
type DownloadMimeType = 'application/zip' | 'text/csv'

/**
 * ダウンロード
 */
export const downloadByUrl = (url: string, fileName?: string) => {
  const link = document.createElement('a')

  link.href = url
  link.download = fileName || ''

  link.click()

  link.remove()
}

export const download = (blob: Blob, fileName: string) => {
  const objectUrl = URL.createObjectURL(blob)
  downloadByUrl(objectUrl, fileName)
  URL.revokeObjectURL(objectUrl)
}

/**
 * bom付きファイルのダウンロード
 */
export const downloadFileWithBom = (
  data: any,
  fileName: string,
  mimeType: DownloadMimeType,
) => {
  download(
    new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), data], { type: mimeType }),
    fileName,
  )
}

/**
 * bom付きCSVファイルのダウンロード
 * @deprecated downloadFileWithBom を使用してください
 */
export const downloadCsvFileWithBom = (data: any, fileName: string) => {
  downloadFileWithBom(data, fileName, 'text/csv')
}

/**
 *
 */
export const downloadFromApiClient = (
  data: any,
  contentDisposition: string | null,
  mimeType: string | null,
) => {
  // ファイルをダウンロードする
  const defaultFileName = `ASUENEESG_${new Date()}`
  let fileName = null
  const regex = /filename="([^"]*)";/

  if (contentDisposition && contentDisposition.includes('filename=')) {
    const match = contentDisposition.match(regex)
    if (match && match[1]) {
      fileName = decodeURIComponent(match[1])
    }
  }

  if (mimeType) {
    const csvIndex = mimeType.indexOf('text/csv')
    const zipIndex = mimeType.indexOf('application/zip')
    if (csvIndex !== -1) {
      downloadFileWithBom(data, fileName ?? `${defaultFileName}.csv`, 'text/csv')
    }
    else if (zipIndex !== -1) {
      download(data, fileName ?? `${defaultFileName}.zip`)
    }
    else {
      // eslint-disable-next-line no-console
      console.error(`Unsupported mimeType: ${mimeType}`)
      throw new Error(`Unsupported mimeType: ${mimeType}`)
    }
  }
}
